<div class="modal-header">
  <app-summary-top class="w-100" [header]="header" [showSave]="false"></app-summary-top>
</div>

<div class="modal-body p-3">
  @if (fields) {
    <app-base-inline-form
      [submitText]="submitText"
      [submitIcon]="submitIcon"
      [model]="reportTemplate"
      [fields]="fields"
      [labelsVertical]="true"
      [fullWidth]="true"
      (submitted)="email()"
    ></app-base-inline-form>
  }

  <div class="row">
    <div class="col-xl-6">
      <app-grid
        gridCssClass="email-attachment-grid"
        stateKey="EmailModalAttachments"
        [header]="additionalHeader"
        [columnDefs]="attachedColumnDefs"
        [rowData]="attachedDocuments"
        (edit)="openDocument($event)"
        (delete)="removeDocument($event)"
      ></app-grid>
    </div>
    <div class="col-xl-6">
      <app-drag-and-drop
        [dragAndDropClass]="dragAndDropClass"
        [dragAndDropProgressClass]="dragAndDropProgressClass"
        [header]="dragAndDropHeader"
        [text]="dragAndDropText"
        [processingText]="processingText"
        (dropFiles)="attachFiles($event)"
      ></app-drag-and-drop>
    </div>
  </div>

  <app-grid
    #contactsGrid
    stateKey="EmailModalContacts"
    [gridCssClass]="gridCssClass"
    [columnDefs]="columnDefs"
    [rowData]="reportTemplate()?.emailContacts"
    [showDelete]="false"
    [showDiscard]="false"
    [header]="gridHeader"
  ></app-grid>
</div>
